export const settings = {
  menu: '환경설정',
  title: '시스템 설정',
  description: '시스템의 각종 설정을 카테고리별로 관리할 수 있습니다.',

  // 그룹 제목과 설명
  deviceDefaultsTitle: '장비 기본값 설정',
  deviceDefaultsDescription: '장비 생성 시 기본 설정값을 관리합니다',
  paginationTitle: '페이지네이션',
  paginationDescription: '목록 페이지의 페이지네이션 설정을 관리합니다',
  environmentTitle: '환경설정',
  environmentDescription: 'MDA의 기본 설정을 관리합니다',
  crmAutomationTitle: 'CRM 자동화',
  crmAutomationDescription: '채널톡 영상 요청 자동화 동작 방식을 관리합니다',
  alertsTitle: '알림 정책',
  alertsDescription:
    '알림 코드별로 Slack 전송 여부, 임계 횟수, 스레드 정책을 관리합니다. 신규 코드는 장비에서 처음 수신되면 자동으로 등록되며, 기본값은 저장만 수행하고 Slack은 전송하지 않습니다.',
  mdaSettingsTitle: 'MDA 설정',
  mdaSettingsDescription: 'MDA 동작 및 런타임 관련 설정을 구성합니다',
  mdaInactiveDestinationTitle: '비활성화 시 이동 병원 설정',
  menuVisibilityTitle: '메뉴 표시 설정',
  menuVisibilityDescription: '사이드바 및 서브메뉴의 노출 여부를 설정합니다',

  // 서브그룹 제목
  recordingSettingTitle: '녹화 설정',
  deviceSettingTitle: '주변 장치 설정',
  functionSettingTitle: '기능 설정',
  recordingScreenSettingTitle: '녹화 화면 설정',
  autoUpdateSettingTitle: '자동 업데이트 설정',

  // cfg1_ 설정 라벨들
  cfg1_max_recording_time: '최대 녹화 시간',
  cfg1_motion_threshold: '모션 감지 감도',
  cfg1_recording_card_select_mode: '녹음 장치 선택',
  cfg1_motion_timeout: '모션 감지 타임아웃',
  cfg1_check_screensaver: '화면보호기 모드 감지',
  cfg1_image_quality_check_enabled: '녹화 중 이미지 품질 체크',
  cfg1_recording_media_validation_enabled: '녹화 종료 후 영상·음성 품질 검사',
  cfg1_notification_feedback: '이상 감지 자동 음성 알림 활성화',
  cfg1_use_printer_cp1300: '프린터 사용(CP1300)',
  cfg1_use_diary_capture: '산모수첩 캡쳐 사용',
  cfg1_check_invalid_barcode: '바코드 유효성 검사',
  cfg1_check_expired_barcode: '1년 이상 지난 바코드 차단',
  cfg1_check_pink_barcode: '핑크바코드 차단',
  cfg1_check_pink_barcode_period: '핑크바코드 기간 차단',
  cfg1_pink_barcode_valid_days: '핑크바코드 사용 가능 기간(일)',
  cfg1_check_online: '네트워크 상태 감지',
  cfg1_capture_sound_level: '캡쳐 비프 음량',
  cfg1_capture_sw_mode: '캡쳐 스위치 설정',
  cfg1_capture_on_recording: '녹화 중 캡쳐 가능 여부',
  cfg1_pause_resume_sound_enabled: '녹화재개/일시정지 소리 ON/OFF',
  cfg1_recording_brightness: '녹화 밝기',
  cfg1_recording_contrast: '녹화 대비',
  cfg1_auto_update: '자동 업데이트 여부',
  cfg1_update_target: '자동 업데이트 대상 버전',
  alertPolicyCode: '코드',
  alertPolicySeverity: '심각도',
  alertPolicySlackEnabled: 'Slack 전송',
  alertPolicySlackThresholdCount: 'Slack 임계 횟수',
  alertPolicyThreadEnabled: '스레드 처리',
  alertPolicyThreadWindowMinutes: '스레드 시간(분)',
  alertPolicyMaxThreadCount: '최대 스레드 갯수',
  alertPolicyAutoCreated: '등록 방식',
  alertPolicyUpdatedAt: '수정 시각',
  alertPolicyGroupBy: '그룹 기준',
  alertPolicySearchPlaceholder: '코드로 검색',
  alertPolicySaveChanges: '변경 저장',
  alertPolicyResetChanges: '변경 취소',
  alertPolicySaveSuccess: '알림 정책이 저장되었습니다.',
  alertPolicySaveError: '알림 정책 저장에 실패했습니다.',
  alertPolicyNoChanges: '변경된 알림 정책이 없습니다.',
  alertPolicyDirtyCount: '{{count}}개의 알림 정책이 변경되었습니다.',
  alertPolicyEmpty: '등록된 알림 정책이 없습니다.',
  alertPolicyTotalCount: '총 {{count}}건',
  alertPolicyAutoCreatedValue: {
    auto: '자동 등록',
    catalog: '기본 카탈로그',
  },
  alertPolicySeverityValue: {
    info: '정보',
    warning: '경고',
    error: '오류',
    critical: '중대',
  },

  // 페이지네이션 설정 라벨들
  devices_per_page: '장비 리스트 개수',
  users_per_page: '사용자 리스트 개수',
  hospitals_per_page: '병원 리스트 개수',
  recordings_per_page: '영상 리스트 개수',
  sessions_per_page: '세션 리스트 개수',
  default_page_size: '기본 페이지 크기',
  cs_per_page: '통합CS 리스트 개수',
  captures_per_page: '캡쳐 리스트 개수',
  bvai_per_page: '베이비매직 리스트 개수',

  // 환경설정 라벨들
  system_timezone: '시스템 타임존',
  system_language: '기본 언어',
  system_date_format: '날짜 포맷',
  system_theme: '테마 설정',
  client_debug_mode: '디버그 모드',
  client_auto_refresh: '자동 새로고침',
  client_session_timeout: '세션 타임아웃',
  client_notification: '알림 설정',
  api_timeout: 'API 타임아웃',
  api_retry_count: 'API 재시도 횟수',
  log_level: '로그 레벨',
  log_retention: '로그 보관기간',
  groups: {
    apiEndpoints: 'API 엔드포인트',
    localization: '지역화 설정',
    defaults: '기본값 설정',
    paginationDefaults: '페이지네이션 기본값',
    mdaDefaults: 'MDA 기본값',
    mdaSidebarVisibility: '사이드바 표시 설정',
    mdaSidebarSubVisibility: '사이드바(서브메뉴) 표시 설정',
    sidebarVisibility: '사이드바 표시 설정',
    sidebarSubVisibility: '사이드바(서브메뉴) 표시 설정',
    menuDashboard: '대시보드',
    menuMonitoring: '종합 모니터링',
    menuTracking: '정산',
    menuCS: '통합CS',
    menuHospital: '병원',
    menuRecording: '초음파/영상',
    menuDevice: '마미박스',
    menuBarcode: '바코드',
    menuCRM: 'CRM',
    menuAdmin: '관리자',
    menuSettings: '환경설정',
    channelTalkRequests: '채널톡 영상 요청',
    alertPolicies: '알림 정책',
    authentication: '인증 설정',
    version: '버전 관리',
  },

  // 사이드바 표시 설정 라벨들
  sidebar: {
    dashboard: '대시보드 메뉴 표시',
    monitoring: '종합 모니터링 메뉴 표시',
    tracking: '정산 메뉴 표시',
    cs: '통합CS 메뉴 표시',
    hospital: '병원 메뉴 표시',
    recording: '초음파/영상 메뉴 표시',
    device: '마미박스 메뉴 표시',
    barcode: '바코드 메뉴 표시',
    crm: 'CRM 메뉴 표시',
    admin: '관리자 메뉴 표시',
    settings: '환경설정 메뉴 표시',
    // 서브메뉴 (트리 스타일이므로 부모명 생략)
    dashboardRecording: '녹화',
    dashboardDevice: '장비',
    dashboardError: '에러',
    dashboardSession: '세션',
    dashboardBabyAi: '베이비AI',
    recordingList: '리스트',
    recordingCapture: '캡쳐',
    recordingBabyAi: '베이비AI',
    recordingMigration: '마이그레이션',
    deviceList: '목록',
    deviceVersion: '버전',
    deviceAgentVersion: '에이전트 버전',
    barcodeSpecial: '스페셜 바코드',
    adminTool: '도구',
    trackingBabymagicsOrders: '베이비매직 주문',
    trackingBarcodesOrders: '바코드 주문',
    trackingPlansPlans: '플랜',
  },

  fields: {
    mainApiUrl: '메인 API URL',
    socketUrl: 'WebSocket URL',
    appApiUrl: '앱 API URL',
    hpaApiUrl: 'BabyAI API URL',
    dashboardApiUrl: '대시보드 API URL',
    erpApiUrl: 'ERP API URL',
    uploaderUrl: '업로더 URL',

    country: '국가 코드',
    timezone: '타임존',
    checkDeviceInterval: '디바이스 상태 확인 간격(분)',
    stage: '배포 단계',

    inactiveHospitalSeq: '비활성 병원',
    inactiveRoomSeq: '비활성 병실',

    nextAuthUrl: 'NextAuth URL',
    googleClientId: 'Google Client ID',

    releaseVersion: '릴리즈 버전',
  },

  placeholder: {
    enterValue: '값을 입력하세요',
    selectOption: '옵션을 선택하세요',
  },

  options: {
    channelTalkNotificationTarget: {
      mda: 'MDA (Client)',
      slack: 'Slack',
      both: '둘 다',
    },
    country: {
      kr: '한국 (KR)',
      us: '미국 (US)',
      id: '인도네시아 (ID)',
      vn: '베트남 (VN)',
    },
    stage: {
      dev: '개발 (Development)',
      prod: '운영 (Production)',
    },
    barcodeCheckMode: {
      inherit: '기존 바코드 유효성 검사 설정 따름',
      disabled: '사용하지 않음',
      enabled: '사용함',
    },
  },

  channeltalk: {
    transfer: {
      mode: '채널톡 영상 이전 실행 모드',
    },
    delete: {
      mode: '채널톡 영상 삭제 실행 모드',
    },
    edit: {
      mode: '채널톡 영상 편집 실행 모드',
    },
    requestReceipt: {
      enabled: '요청 수신 메시지 표시',
      message: '요청 수신 메시지 내용',
      delaySeconds: '요청 수신 메시지 지연 시간(초)',
    },
    decisionMessage: {
      defaultSend: '승인/거절 메시지 기본 전송 여부',
      delaySeconds: '승인/거절 메시지 지연 시간(초)',
      closeAfterProcess: '처리 후 상담 종료 여부',
    },
    notification: {
      target: '채널톡 요청 알림 위치',
      slackChannelId: '채널톡 요청 Slack 채널 ID/코드',
    },
  },

  actions: {
    save: '저장',
    cancel: '취소',
    reset: '초기화',
    apply: '적용',
  },

  messages: {
    saveSuccess: '설정이 성공적으로 저장되었습니다.',
    saveError: '설정 저장 중 오류가 발생했습니다.',
    resetConfirm: '모든 설정을 초기화하시겠습니까?',
    invalidUrl: '올바른 URL 형식이 아닙니다.',
    requiredField: '필수 항목입니다.',
    dataLoadError: '데이터 로딩 실패',
    noSettingsAvailable: '설정이 없습니다',
    changedSettingsCount: '개의 설정이 변경되었습니다',
    noChangedSettings: '변경된 설정이 없습니다.',
    resetAllConfirm: '모든 변경사항을 취소하고 원래 상태로 되돌리시겠습니까?',
    resetAllSuccess: '모든 변경사항이 취소되었습니다.',
    noSearchResults: '검색 결과가 없습니다',
    selectCategory: '카테고리를 선택해주세요',
  },

  ui: {
    searchPlaceholder: '설정명, 키, 설명으로 검색',
    filterOptions: {
      all: '모든 설정',
      changed: '변경된 설정',
      default: '기본값 설정',
    },
    buttons: {
      refresh: '새로고침',
      saveAll: '모두 저장',
      cancelAll: '모두 취소',
    },
    categoryTitle: '설정 카테고리',
  },

  // UI consumption aliases (flattened keys expected by components)
  // Filters
  filterAll: '모든 설정',
  filterChanged: '변경된 설정',
  filterDefault: '기본값 설정',
  // Buttons
  refresh: '새로고침',
  saveAll: '모두 저장',
  cancelAll: '모두 취소',
  // Placeholders
  searchPlaceholder: '설정명, 키, 설명으로 검색',
  // Messages (flattened)
  saveSuccess: '설정이 성공적으로 저장되었습니다.',
  saveError: '설정 저장 중 오류가 발생했습니다.',
  dataLoadError: '데이터 로딩 실패',
  noSettingsAvailable: '설정이 없습니다',
  changedSettingsCount: '개의 설정이 변경되었습니다',
  noChangedSettings: '변경된 설정이 없습니다.',
  resetAllConfirm: '모든 변경사항을 취소하고 원래 상태로 되돌리시겠습니까?',
  resetAllSuccess: '모든 변경사항이 취소되었습니다.',
  noSearchResults: '검색 결과가 없습니다',
  selectCategory: '카테고리를 선택해주세요',
};
